module.exports = __webpack_public_path__ + "63345f4316bce74245661a160291cfc0.pdf";